import {
  Box,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { css } from "@emotion/react";
import React from "react";
import { FiBell } from "react-icons/fi";
import { color } from "../../utils/theme";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducer/rootReducer";

export function Bell() {
  const user = useSelector((state: RootState) => state.user);

  return (
    <Menu>
      <MenuButton>
        <IconButton
          css={css`
            position: relative !important;
          `}
          py={"2"}
          colorScheme={"gray"}
          aria-label={"Notifications"}
          size={"lg"}
          icon={
            <>
              <FiBell />
              <Box
                as={"span"}
                color={"white"}
                position={"absolute"}
                top={"6px"}
                right={"4px"}
                fontSize={"0.8rem"}
                bgColor={"red"}
                borderRadius={"llg"}
                zIndex={9999}
                p={"1px"}
              >
                {user.user?.notifications?.length
                  ? user.user?.notifications?.length
                  : 0}
              </Box>
            </>
          }
        />
      </MenuButton>
      <MenuList
        bg={color.secondary}
        alignContent={"center"}
        justifyContent={"center"}
        w={250}
      >
        {user.user?.notifications?.map((notification, index) => (
          <MenuItem key={index}>
            <Text>{notification.name}</Text>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
